const initialState = {
   userTemplates: [],
   activityTypes: [],
   changesSaved: false,
   defaultTemplates: [],
   currentSection: 0,
   currentTemplate: null,
   fetched: true,
}

export default function (state = initialState, action) {
   switch (action.type) {
      case 'GET_DEFAULT_TEMPLATES_FULFILLED': {
         return {
            ...state,
            defaultTemplates: action.payload.data
         }
      }

      case 'GET_TEMPLATE_ACTIVITY_TYPES_FULFILLED': {
         return {
            ...state,
            activityTypes: action.payload.data
         }
      }

      case "ADD_TEMPLATE_PENDING": {
         return {...state, fetching: true,
          changesSaved: false}
      }
      case "ADD_TEMPLATE_REJECTED": {
         return {...state, fetching: false,  changesSaved: false, error: action.payload}
      }
      case "ADD_TEMPLATE_FULFILLED": {
         return {
            ...state,
            fetching: false,
            fetched: true,
            currentTemplate: action.payload.data,
            currentSection: 0,
            changesSaved: false
         }
      }
      case "SAVE_TEMPLATE_DETAILS_USED_FOR_ADD_TEMPLATE": {
         return {
            ...state,
            presetTemplateUsed: action.payload,
         }
      }

      case "FETCH_TEMPLATES_PENDING": {
         return {...state, fetching: true, fetched: false}
      }
      case "FETCH_TEMPLATES_REJECTED": {
         return {...state, fetching: false, fetched: true, error: action.payload}
      }
      case "FETCH_TEMPLATES_FULFILLED": {
         return {
            ...state,
            fetching: false,
            fetched: true,
            userTemplates: action.payload.data,
         }
      }

      case "FETCH_TEMPLATES_NOT_SYNC_PENDING": {
         return {...state, fetching: true, fetched: false}
      }
      case "FETCH_TEMPLATES_NOT_SYNC_REJECTED": {
         return {...state, fetching: false, fetched: true, error: action.payload}
      }
      case "FETCH_TEMPLATES_NOT_SYNC_FULFILLED": {
         return {
            ...state,
            fetching: false,
            fetched: true,
            userTemplates: action.payload.data,
         }
      }

      case "DISPLAY_CHANGE": {
         return {
            ...state,
            currentTemplate: action.payload,
            changesSaved: false,
            fetched: true,
         }
      }
      case "EDIT_TEMPLATE_PENDING": {
         return {...state, fetching: true, fetched: false, changesSaved: false}
      }
      case "EDIT_TEMPLATE_REJECTED": {
         return {...state, fetching: false, fetched: true, changesSaved: false, error: action.payload}
      }
      case "EDIT_TEMPLATE_FULFILLED": {
         return {
            ...state,
            fetching: false,
            fetched: true,
            currentTemplate: action.payload.data,
            changesSaved: true,
         }
      }

      case "CHANGE_SELECTED_TEMPLATE_PENDING": {
         return {...state, fetching: true, fetched: false, changesSaved: false}
      }
      case "CHANGE_SELECTED_TEMPLATE_REJECTED": {
         return {...state, fetching: false, fetched: true, changesSaved: false, error: action.payload}
      }
      case "CHANGE_SELECTED_TEMPLATE_FULFILLED": {
         return {
            ...state,
            fetching: false,
            fetched: true,
            currentTemplate: action.payload.data,
            currentSection: 0,
            changesSaved: false,
         }
      }
      case "EDIT_PICTURE_TEMPLATE_FULFILLED" : {
         return {
            ...state,
            fetching: false,
            fetched: true,
            currentTemplate: {
               ...state.currentTemplate,
               picUrl: action.payload.data,
            },
            currentSection: 0,
         }
      }

      case "DELETE_TEMPLATE_PENDING": {
         return {...state, fetching: true, fetched: false, changesSaved: false}
      }
      case "DELETE_TEMPLATE_REJECTED": {
         return {...state, fetching: false, fetched: true, changesSaved: false, error: action.payload}
      }
      case "DELETE_TEMPLATE_FULFILLED": {
         return {
            ...state,
            fetching: false,
            fetched: true,
            currentTemplate: null,
         }
      }
      default:
         return state;

      }

   }



// WEBPACK FOOTER //
// ./src/reducers/templatesReducer.js